angular.module('unica_event_tag.event_tag_services')

.factory('EventTagEditService', function ($http, getBaseApiURL) {

	var eventTagEditService = {};

	eventTagEditService.update = function (eventTagData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-tag/update/' + eventTagData.id,
			data: eventTagData
		}).then(function(result) {

			if ( result ) {
				return result.data.eventTag;
			}

		});

	};

	return eventTagEditService;
});